import { Component, Vue } from 'vue-property-decorator'
import { GQLLocalCart } from '~/graphql/__generated__/interfacesLocal'
import { GQL_LOCAL_CART_MARXY } from '~/graphql/gqlLocal/localCart'
import { marxyEvents } from '~/utils/marxy/eventTracking'

@Component({
  apollo: {
    marxyCartData: {
      fetchPolicy: 'cache-only',
      prefetch: false,
      query: GQL_LOCAL_CART_MARXY,
      update: (data: any) => data.cart,
    },
  },
})
class MarxyTrackingMixin extends Vue {
  marxyCartData: GQLLocalCart

  async marxyTrackCartUpdate(articleId: string) {
    // TODO - should download products from graphql not from web api
    const variants = await this.$webApi.findVariants([articleId])
    const variantList = this.marxyCartData.articles.map((article: any) => ({
      count: Number(article.count),
      price: article.price.actual,
      variant: article.articleId,
    }))

    const product = variants.entities[0]
    const marxyPayload = this.mapMarxyPayload(
      this.marxyCartData,
      product,
      variantList
    )

    if (!marxyPayload) return

    const { marxy } = window
    if (marxy?.eventTracking) {
      marxyEvents.TRACK_CART_UPDATE(marxyPayload)
    }
  }

  mapMarxyPayload(cart: GQLLocalCart, product: any, variantList: any) {
    if (!product) return null
    const categories = product.mainMenuPath

    return {
      action: cart.action.action === 'add' ? 'add' : 'remove',
      brand: product.brandTitle,
      category_id: product.product.productTypeId,
      category_name: categories[categories.length - 1],
      product_id: product.product.entityId,
      quantity: Number(cart.action.amount),
      total_price: cart.price.total,
      total_quantity: cart.amount.pieces,
      variant_id: String(product.variantId),
      variant_list: variantList,
    }
  }
}

export default MarxyTrackingMixin
